// API response handler
export const handleApiResponse = (response) => {
  if (!response.data) {
    throw new Error('Invalid response from server');
  }
  return response.data;
};

// API error handler
export const handleApiError = (error) => {
  const data = error.response?.data;
  return {
    success: false,
    message: data?.message || 'Something went wrong',
    errors: data?.errors || [], // validation field errors
    status: error.response?.status || 500,
  };
};
